import React from 'react';
import { Box, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

/**
 * Student-scoped overview stat card.
 *
 * Presentation only — matches the themed mockup's `.stat` card (icon chip on
 * top, large number, label, muted subtitle). All values, icons, colours and
 * the optional `onClick` handler are supplied by the parent dashboard; this
 * component contains no data fetching, navigation, or business logic.
 */
const OverviewStatCard = ({
  title,
  value,
  icon,
  color = 'primary',
  subtitle,
  onClick,
}) => (
  <Box
    onClick={onClick}
    sx={{
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: 1.5,
      p: 2.25,
      borderRadius: '18px',
      border: '1px solid',
      borderColor: 'divider',
      backgroundColor: 'background.paper',
      cursor: onClick ? 'pointer' : 'default',
      transition: 'all 0.18s ease-in-out',
      '&:hover': {
        borderColor: 'action.disabled',
        boxShadow: '0 10px 24px -16px rgba(17,26,46,0.4)',
      },
    }}
  >
    <Box
      sx={{
        width: 44,
        height: 44,
        borderRadius: '12px',
        display: 'grid',
        placeItems: 'center',
        color: `${color}.main`,
        bgcolor: (theme) => alpha(theme.palette[color].main, 0.13),
        '& svg': { fontSize: 18 },
      }}
    >
      {icon}
    </Box>
    <Box>
      <Typography sx={{ fontSize: 28, fontWeight: 800, lineHeight: 1, color: 'text.primary' }}>
        {value}
      </Typography>
      <Typography sx={{ fontWeight: 600, fontSize: '13.5px', color: 'text.primary', mt: '2px' }}>
        {title}
      </Typography>
    </Box>
    <Typography sx={{ fontSize: '12.5px', color: 'text.secondary' }}>
      {subtitle}
    </Typography>
  </Box>
);

export default OverviewStatCard;
